import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BaseScholarshipCard as ScholarshipCardComponent } from './BaseScholarshipCard';
import { ScholarshipCard as ScholarshipCardData, ScholarshipStatus } from '@common-types';

import { SCHOLARSHIPS_PATH } from '@constants/ROUTES';

import { CollegeLocation } from '@interfaces/location';

import { getFromScholarshipLocation } from '@utils/breadcrumbs';

import useFavoriteScholarshipsStore from '@store/FavoriteScholarshipsStore';
import useUserPreferencesStore from '@store/UserPreferencesStore';
import useEducationPlannerStore from '@store/EducationPlannerStore';
import useApplyingScholarshipsStore from '@store/ApplyingScholarshipsStore';

interface ScholarshipCardProps {
  scholarship: ScholarshipCardData;
  isWiderCardType?: boolean;
  isViewOnly?: boolean;
}

export const ScholarshipCard = (props: ScholarshipCardProps) => {
  const { scholarship, isWiderCardType = false, isViewOnly = false } = props;

  const navigate = useNavigate();
  const location: CollegeLocation = useLocation();

  const scholarshipFavorites = useUserPreferencesStore((state) => state.scholarshipFavorites);
  const { applyingScholarships } = useEducationPlannerStore((state) => state.userPlanning);

  const toggleFavorite = useFavoriteScholarshipsStore((state) => state.toggleFavorite);
  const { changeApplyStatus, applyScholarship } = useApplyingScholarshipsStore((state) => state);

  const routeLocation = location.pathname.includes(SCHOLARSHIPS_PATH)
    ? `${location.pathname}${location.hash}`
    : location.pathname;

  const isFavoriteScholarship = useMemo(() => {
    return !!scholarshipFavorites?.find((item) => item.id === scholarship.id);
  }, [scholarshipFavorites]);

  const initialApplyStatus = useMemo(
    () =>
      applyingScholarships?.find((item) => item.id === scholarship.id)?.applicationStatus || ScholarshipStatus.CHANGED,
    [applyingScholarships, scholarship.id],
  );

  const handleToggleFavorite = () => {
    void toggleFavorite(scholarship.id, isFavoriteScholarship);
  };

  const handleMoreDetails = () => {
    navigate(`/scholarships/${scholarship.id}`, { state: getFromScholarshipLocation(routeLocation) });
  };

  const scholarshipData: ScholarshipCardData = { ...scholarship, isFavorite: isFavoriteScholarship };

  return (
    <ScholarshipCardComponent
      key={scholarship.id}
      isWiderCardType={isWiderCardType}
      isViewOnly={isViewOnly}
      scholarship={scholarshipData}
      initialApplyStatus={initialApplyStatus}
      onMoreDetails={handleMoreDetails}
      onFavoriteToggle={handleToggleFavorite}
      onApplyScholarship={applyScholarship}
      onChangeApplyStatus={changeApplyStatus}
    />
  );
};
